/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum HealthHistoryDiseasesViewerAliases {
  ACTION_INACTIVATE_HEALTH_HISTORY_DISEASES = 'action-inactivate-health-history-diseases',
  ACTION_NEW_HEALTH_HISTORY_DISEASES = 'action-new-health-history-diseases',
  ACTION_REVIEW_HEALTH_HISTORY_DISEASES = 'action-review-health-history-diseases',
  CHECKBOX_DENIES_DISEASES = 'checkbox-denies-diseases',
  CHECKBOX_DISPLAY_PATIENT_ALERTS = 'checkbox-display-patient-alerts',
  CHECKBOX_INSERT_DIAGNOSIS_LIST = 'checkbox-insert-diagnosis-list',
  CHECKBOX_INSERT_PROBLEMS_LIST = 'checkbox-insert-problems-list',
  CONTEXTUAL_BAR = 'contextual-bar',
  FIELD_APPROACH = 'field-approach',
  FIELD_CID = 'field-cid',
  FIELD_DENIES_DISEASES = 'field-denies-diseases',
  FIELD_DISEASES_TEXT_FREE = 'field-diseasesTextFree',
  FIELD_DISPLAY_PATIENT_ALERTS = 'field-display-patient-alerts',
  FIELD_END_DATE = 'field-end-date',
  FIELD_HIGHLIGHT_INTENSITY_SEVERITY = 'field-highlight-intensity-severity',
  FIELD_INSERT_DIAGNOSIS_LIST = 'field-insert-diagnosis-list',
  FIELD_INSERT_PROBLEMS_LIST = 'field-insert-problems-list',
  FIELD_NOTES = 'field-notes',
  FIELD_PATHOLOGIE = 'field-pathologie',
  FIELD_RECORD_DATE = 'field-record-date',
  FIELD_REVIEW_DATE = 'field-review-date',
  FIELD_REVIEW_USERNAME = 'field-review-username',
  FIELD_SAE = 'field-sae',
  FIELD_SECURITY_LEVEL = 'field-security-level',
  FIELD_SITUATION = 'field-situation',
  FIELD_START_DATE = 'field-start-date',
  FORM_HEALTH_HISTORY_DISEASES_VIEWER = 'form-health-history-diseases-viewer',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  LAYOUT_HEALTH_HISTORY_DISEASES_VIEWER = 'layout-health-history-diseases-viewer',
  PANEL_FORM = 'panel-form',
  RADIO_GROUP_HIGHLIGHT_INTENSITY_SEVERITY = 'radio-group-highlight-intensity-severity',
  TEXT_APPROACH = 'text-approach',
  TEXT_AREA_NOTE = 'text-area-note',
  TEXT_CID = 'text-cid',
  TEXT_END_DATE = 'text-end-date',
  TEXT_HEALTH_HIS_PATHOLOGY = 'text.health-his-pathology',
  TEXT_RECORD_DATE = 'text-record-date',
  TEXT_REVIEW_DATE = 'text-review-date',
  TEXT_REVIEW_USERNAME = 'text-review-username',
  TEXT_SAE = 'text-sae',
  TEXT_SECURITY_LEVEL = 'text-security-level',
  TEXT_SITUATION = 'text-situation',
  TEXT_START_DATE = 'text-start-date',
  TWS_DISEASE_TEXT_FREE = 'tws.disease-text-free',
}
export { HealthHistoryDiseasesViewerAliases };
